/**
 * Color tokens shared by OperationalExcellenceHub and the Top Customers
 * pages -- confirmed byte-identical hex values in both files before this
 * extraction. Each file keeps any color that's genuinely its own (e.g.
 * L3_ACCENT differs between the two -- not the same token, don't merge it).
 */

export const DEEP_GREEN = '#1A2E22';
export const MUTED = '#666666';
export const INK = '#1A1A1A';
export const NEUTRAL_SURFACE = '#F8F9FA';
export const L1_ACCENT = '#5b4fbb';
export const L1_BADGE_BG = '#ece9f9';
export const L2_ACCENT = '#2b6cb0';
export const L2_BADGE_BG = '#e3ecf7';
export const INCIDENT_ACCENT = '#c62828';
export const WARN_ORANGE = '#c85a00';
// Major incident highlight (SRE list rows and the SRE tile badge).
export const MAJOR_INCIDENT_ACCENT = '#d84315';
export const MAJOR_INCIDENT_BG = '#fce8de';
export const MAJOR_INCIDENT_BG_HOVER = '#f9d9c8';
// Top Customers tile and box: dark green rgb(18, 48, 21). Hex, not rgb(), so `${TOP_CUSTOMERS_ACCENT}ee` alpha suffixes stay valid.
export const TOP_CUSTOMERS_ACCENT = '#123015';
export const TOP_CUSTOMERS_ACCENT_BG = '#e4ece5';
